import React from 'react'
import classnames from 'classnames'
import { pathOr } from 'ramda'
import { formatCurrency } from '../../../utils/utils'

const Section = ({ children, style }) => {
  return (
    <div className="summary_section" style={style}>
      {children}
    </div>
  )
}

const Row = ({ right, left, isDiscount, isTotal }) => {
  return (
    <div className={classnames('summary_row', { isDiscount, isTotal })}>
      <span className="left">{left}</span>
      <span className="right">{right}</span>
    </div>
  )
}

const Charges = props => {
  const { selectedDeliveryDay, isLoading, orderSummary, mealCount } = props

  const deliveryDate = pathOr('', ['label'], selectedDeliveryDay)
  const subtotal = pathOr(0, ['subtotal'], orderSummary)
  const deliveryFee = pathOr(0, ['shipping'], orderSummary)
  const taxes = pathOr(0, ['taxes'], orderSummary)
  const discount = pathOr(0, ['discount'], orderSummary)
  const grandTotal = pathOr(0, ['grandTotal'], orderSummary)

  const coupon = pathOr('', ['coupon'], orderSummary)
  const discountLabel = coupon
    ? `Discount (${coupon.toUpperCase()})`
    : 'Discount'

  return (
    <div
      className={classnames('cookunity__checkout_charges', {
        loading: isLoading
      })}>
      <Section style={{ paddingTop: 0 }}>
        <Row left="Delivery" right={deliveryDate} />
      </Section>

      <Section>
        <Row left={`${mealCount} meals`} right={formatCurrency(subtotal)} />
        <Row left="Delivery Fee" right={formatCurrency(deliveryFee)} />
        <Row left="Taxes" right={formatCurrency(taxes)} />
        {!!discount && (
          <Row
            left={discountLabel}
            right={formatCurrency(discount)}
            isDiscount
          />
        )}
      </Section>

      <Section>
        <Row left="Total" right={formatCurrency(grandTotal)} isTotal />
      </Section>
    </div>
  )
}

export default Charges



// WEBPACK FOOTER //
// ./src/modules/Checkout/Charges/Charges.jsx